import { useAuth, useRequestUser } from "../core/Auth";
import { useEffect, useState } from "react";
import { LayoutSplashScreen } from "../../../layout/core";
import { useParams } from "react-router-dom";

export const TokenAuth = () => {
  const { token: base64Token } = useParams();
  const { getUserByToken } = useRequestUser();
  const { logout, setUser, saveAuth } = useAuth();
  const [showSplashScreen, setShowSplashScreen] = useState(true);

  useEffect(() => {
    const tokenFromUrl = base64Token ? atob(base64Token) : null;
    const storedToken = localStorage.getItem("auth_token");

    const token = tokenFromUrl || storedToken;

    if (!token) {
      setShowSplashScreen(false);
      return;
    }

    // Save the token to localStorage if it came from the URL
    if (tokenFromUrl) {
      localStorage.setItem("auth_token", tokenFromUrl);
    }

    setShowSplashScreen(true);
    getUserByToken(token)
      .then((user) => {
        saveAuth({ authType: "Custom", token });
        setUser(user);
      })
      .catch(() => {
        logout();
        localStorage.removeItem("auth_token");
      })
      .finally(() => {
        setShowSplashScreen(false);
      });

    // eslint-disable-next-line
  }, [base64Token]);

  return showSplashScreen ? <LayoutSplashScreen /> : <></>;
};
